<template>
    <section id="content">

        <div class="content-wrap">

            <div class="container clearfix">

                <div class="col_full">
                    <div class="panel card-default nobottommargin">
                        <div class="card-body" style="padding: 40px;">
                            <form method="post" action="https://www.tdadental.com/brokers/portal.php" ref="form" @submit.prevent="submitForm()" @keyup.enter.native="submitForm()">
                                <h3>Login to your Account</h3>

                                <div class="col_full">
                                    <label for="login-form-username">Username:</label>
                                    <input id="login-form-username" name="username" v-model="user.username" class="form-control"
                                           autocomplete="off">
                                </div>

                                <div class="col_full">
                                    <label for="login-form-password">Password:</label>
                                    <input type="password" name="password" id="login-form-password" v-model="user.password"
                                           class="form-control" autocomplete="off">
                                </div>

                                <div v-if="loginError" class="alert alert-danger">{{loginError.msg}}</div>
                                <div class="col_full nobottommargin">
                                    <button class="button button-3d button-black nomargin" id="login-form-submit"
                                            name="login-form-submit" @click="submitForm()" v-if="!processing">Login
                                    </button>
                                    <div v-if="processing">Processing</div>
<!--                                    <a href="#" class="fright">Forgot Password?</a>-->
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>

        </div>

    </section>

</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'Login',
        data () {
            return {
                user: {
                    username: '',
                    password: ''
                }
            }
        },
        computed: {
            ...mapGetters(['currentUser', 'processing', 'loginError'])
        },
        methods: {
            ...mapActions(['login']),
            submitForm () {
                if(isNaN(this.user.username)) {
                    this.login(this.user)
                } else {
                    this.$refs.form.submit();
                }
            }
        },
        watch: {
            currentUser (val) {
                if (val && val.id) {
                    switch (true) {
                        case (val.user_types.producer && val.user_types.producer.id !== undefined):
                            this.$router.push('/dashboard/producer')
                            break
                        case (val.user_types.general_agent && val.user_types.general_agent.id) !== undefined:
                            this.$router.push('/dashboard/general-agent')
                            break
                        case (val.user_types.group_admin && val.user_types.group_admin.id !== undefined):
                            this.$router.push('/dashboard/group-admin')
                            break
                        default:
                            this.$router.push('/dashboard')
                            break
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
